import { getSdk } from './generated.js';
import { GraphQLClient } from 'graphql-request';
export * from './generated.js';
export default (url, options) => {
    if (!url.includes('://')) {
        url = 'https://' + url;
    }
    return getSdk(new GraphQLClient(url, options));
};
//# sourceMappingURL=index.js.map